(ns frontend.ui.component.lp-portal.voima-components.pdf.column.view
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]))

;; TODO This duplicate of frontend.ui.page.lp-portal.landing-page.private-equity.pdf.view/margin
;; should probably belong to a PDF submap of the theme
(def ^:private margin 15)

(defn column
  [& children]
  {:stack  children
   :margin [0 0 30 0]})

(defn one-third-column
  [& children]
  {:stack  children
   :margin [0 0 (* margin 2) 0]
   :width  (int (* page/page-width (/ 1 3)))})

(defn half-column
  [& children]
  {:stack  children
   :margin [0 0 (* margin 2) 0]
   :width  (int (* page/page-width (/ 1 2)))})

(defn columns
  [& children-list]
  {:columns (map one-third-column children-list)})

(defn half-columns
  [& children-list]
  {:columns (map half-column children-list)})

(defn columns-2-to-1
  [two-third-child one-third-child]
  {:columns [(-> (column two-third-child)
                 (assoc :width (int (* page/page-width (/ 2 3))))
                 (assoc :margin [0 0 (* 2 margin) 0]))

             (-> (column one-third-child)
                 (assoc :width (int (* page/page-width (/ 1 3))))
                 (assoc :margin [0 0 margin 0]))]})

(defn columns-1-to-2
  [one-third-child two-third-child]
  {:columns [(-> (column one-third-child)
                 (assoc :width (int (* page/page-width (/ 1 3))))
                 (assoc :margin [0 0 margin 0]))

             (-> (column two-third-child)
                 (assoc :width (int (* page/page-width (/ 2 3))))
                 (assoc :margin [0 0 (* 2 margin) 0]))]})
